export * from './focus-input.directive';



// WEBPACK FOOTER //
// /app/src/app/directives/focus-input/index.ts